import SIGNIN_ENV from '~/constants/signinEnv'

export const useLoginSdkStore = defineStore('loginSdk', () => {
  const { fetch, setEnv } = useAdotFetch()

  setEnv(SIGNIN_ENV)

  const requestValidate = ref<RequestValidateLoginSdkDto>({
    requestType: '',
    user: null,
    terms: null,
    guardianCredential: null
  })

  const responseValidate = ref<ResponseValidateLoginSdkDto>({
    validationCode: '',
    requiredCredential: null,
    requiredTermsAgreement: null,
    disabledUser: null
  })

  const pocId = ref<string>('')

  const terms = ref<RequestValidateTermsLoginSdkDto[]>([])

  const fetchValidate = async (body: RequestValidateLoginSdkDto) => {
    const response = await fetch<ResponseValidateLoginSdkDto>('/oauth/credential/validate', {
      method: 'POST',
      body,
      credentials: 'include'
    })

    return response
  }

  const fetchSignin = async (): Promise<ResponseLoginDto | null> => {
    const { data } = await fetch('/login', {
      method: 'POST',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    })

    return data
  }

  const getTermsGroups = async (groupCodes: string): Promise<ResponseTermsLoginSdkDto | null> => {
    const baseStore = useSigninBaseStore()

    const data = await baseStore.getSigninTerms(groupCodes)

    return data
  }

  const setTerms = (data: RequestValidateTermsLoginSdkDto[]) => {
    terms.value = data
  }
  const getTerms = () => {
    return deepClone(terms.value)
  }

  const setPocId = (code: string) => {
    pocId.value = code
  }

  return {
    fetchValidate,
    fetchSignin,
    terms,
    requestValidate,
    responseValidate,
    getTermsGroups,
    setTerms,
    getTerms,
    pocId,
    setPocId
  }
})
